/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgOfficeCatchUp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m1152 128 512 512v1280H256v-640h128v512h1152V768h-512V256H384v343L263 865h-7V128h896zm0 512h332l-332-332v332zM544 942l-96 211H128v-128h238l178-391 297 650 140-259h299v128h-222l-226 418-288-629z"
    }));
export default SvgOfficeCatchUp;
